import { ActionCreatorAction, createTypedAction } from 'src/actions/types';

export const enum NotificationsActionType {
  DISMISSED_NOTIFICATION = 'DISMISSED_NOTIFICATION',

  MAX_FILE_SIZE_EXCEEDED = 'MAX_FILE_SIZE_EXCEEDED',
  VOICEBOX_GENERATE_DATA_FAILED = 'VOICEBOX_GENERATE_DATA_FAILED',
  VOICEBOX_GENERATE_DATA_MODEL_FAILED = 'VOICEBOX_GENERATE_DATA_MODEL_FAILED',
  VOICEBOX_GENERATE_QUERIES_FAILED = 'VOICEBOX_GENERATE_QUERIES_FAILED',
  VOICEBOX_GENERATE_QUESTIONS_FAILED = 'VOICEBOX_GENERATE_QUESTIONS_FAILED',
  VOICEBOX_GENERATE_SCORES_FAILED = 'VOICEBOX_GENERATE_SCORES_FAILED',
  VOICEBOX_GENERATE_SUMMARY_FAILED = 'VOICEBOX_GENERATE_SUMMARY_FAILED',
  VOICEBOX_SUGGESTIONS_FAILED = 'VOICEBOX_SUGGESTIONS_FAILED',
}

export const notificationsActionCreators = {
  dismissedNotification: (notificationId: string) =>
    createTypedAction(NotificationsActionType.DISMISSED_NOTIFICATION, {
      notificationId,
    }),

  maxFileSizeExceeded: () =>
    createTypedAction(NotificationsActionType.MAX_FILE_SIZE_EXCEEDED),

  voiceboxGenerateDataFailed: () =>
    createTypedAction(NotificationsActionType.VOICEBOX_GENERATE_DATA_FAILED),
  voiceboxGenerateDataModelFailed: () =>
    createTypedAction(
      NotificationsActionType.VOICEBOX_GENERATE_DATA_MODEL_FAILED
    ),
  voiceboxGenerateQueriesFailed: (questionIds: string[]) =>
    createTypedAction(
      NotificationsActionType.VOICEBOX_GENERATE_QUERIES_FAILED,
      { questionIds }
    ),
  voiceboxGenerateQuestionsFailed: () =>
    createTypedAction(
      NotificationsActionType.VOICEBOX_GENERATE_QUESTIONS_FAILED
    ),
  voiceboxGenerateScoresFailed: (questionIds: string[]) =>
    createTypedAction(NotificationsActionType.VOICEBOX_GENERATE_SCORES_FAILED, {
      questionIds,
    }),
  voiceboxGenerateSummaryFailed: () =>
    createTypedAction(NotificationsActionType.VOICEBOX_GENERATE_SUMMARY_FAILED),
  voiceboxSuggestionsFailed: () =>
    createTypedAction(NotificationsActionType.VOICEBOX_SUGGESTIONS_FAILED),
};

export type NotificationsAction = ActionCreatorAction<
  typeof notificationsActionCreators
>;
